<template>
   <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <button-export
      v-if="results.length"
      title="Relatório R2"
      @export-pdf="PDFExport"
      :print="true"
      @print="PDFPrint"
    />
    <div class="col-md-12 px-0">
      <the-filters
        :creators="creators"
        :farms="farms"
        :services="services"
        @get-farms="getFarms"
        @get-services="getServices"
        @get-results="getResults"
        @update-filter="updateFilter"
      />
    </div>
    <div class="col-12 px-0 r2-wrapper">
      <table id="report-r2" class="table table-striped table-bordered table-sm">
        <thead>
          <tr>
            <td v-for="(head, i) in headers" :key="i" class="text-center">{{ head.text }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(animal, i) in results" :key="i">
            <td>{{ animal.register }}</td>
            <td>{{ animal.name }}</td>
            <td v-for="(serv, i) in animal.services" :key="i + 100">
              <div class="col-12 d-flex flex-column align-items-center">
                <span class="my-1" v-if="hasValue(serv ? serv.ccs : '')">
                  <span class="tooltip-title">CCS:</span>
                  <span :style="'color:'+setColor(serv ? serv.ccs : 0)+' !important'">{{returnParsedFloat(serv ? serv.ccs : "")}}</span>
                </span>
                <span class="my-1" v-if="hasValue(serv ? serv.weight_total : '')">
                  <span class="tooltip-title">Leite KG:</span>
                  {{returnParsedFloat(serv ? serv.weight_total : "")}}
                </span>
                <span class="my-1" v-if="hasValue(serv ? serv.fat : '')">
                  <span class="tooltip-title">Gord. %:</span>
                  {{returnParsedFloat(serv ? serv.fat : "")}}
                </span>
                <span class="my-1" v-if="hasValue(serv ? serv.protein : '')">
                  <span class="tooltip-title">Prot. %:</span>
                  {{returnParsedFloat(serv ? serv.protein : "")}}
                </span>
                <span class="my-1" v-if="hasValue(serv ? serv.urea : '')">
                  <span class="tooltip-title">Ureia:</span>
                  {{returnParsedFloat(serv ? serv.urea : "")}}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
   </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ButtonExport from "@/components/layout/ButtonExport.vue";
import TheFilters from "./TheFilters.vue";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import helpers from "@/mixins/helpers";
import { drawOfficialHeader, loadOfficialLogo } from "@/utils/officialPdf";
export default {
  name: "ReportR2",
  mixins: [helpers],
  components: {
    TheFilters,
    ButtonExport
  },
  data: () => ({
    filter: {},
  }),
  computed: {
    ...mapState("creators", [
      "creators"
    ]),
    ...mapState("farms", [
      "farms"
    ]),
    ...mapState("service", [
      "services"
    ]),
    ...mapState("r2", [
      "headers",
      "results"
    ])
  },
  methods: {
    ...mapActions("creators", [
      "actionGetCreators"
    ]),
    ...mapActions("farms", [
      "actionGetFarms"
    ]),
    ...mapActions("service", [
      "actionGetServices"
    ]),
    ...mapActions("r2", [
      "actionGetResults"
    ]),
    ...mapMutations("r2", [
      "SET_RESET_RESULTS"
    ]),
    returnParsedFloat(value) {
      if(value && value !== "") {
        const string = value.toString();
        if(string.includes(".")) {
          return parseFloat(string).toFixed(2);
        } else {
          return parseFloat(string);
        }
      } else {
        return "-";
      }
    },
    // esconde a linha quando nao ha valor -> mesmo criterio do "-" que ja era renderizado
    hasValue(value) {
      return this.returnParsedFloat(value) !== "-";
    },
    async getFarms(value) {
      await this.actionGetFarms(value);
    },
    async getServices(value) {
      const payload = (value && typeof value === "object") ? value : {};
      await this.actionGetServices({...payload, summary:true});
    },
    async getResults(value) {
      await this.actionGetResults(value);
    },
    setColor(ccs) {
      const value = parseFloat(ccs);
      if (value > 500) return "#ff0000";
      if (value < 200) return "#0400ff";
      return "#000000";
    },
    updateFilter(value) {
      this.filter = value;
    },
    async PDFExport(print = false) {
      const printWindow = print ? window.open("", "_blank") : null;
      const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
      const logo = await loadOfficialLogo();
      const creator = this.creators.find(e => e.id === this.filter.person_id);
      const farm = this.farms.find(e => e.id === this.filter.farm_id);
      const service = this.services.find(e => e.id === this.filter.service_id);
      const details = [
        `Criador: ${creator?.name || "-"}    Fazenda: ${farm?.name || "-"}`,
        `Serviço: ${service ? this.parseDate(service.date) : "-"}    Nº ${service?.code || "-"}`,
        "CCS/1000: azul abaixo de 200; vermelho acima de 500; preto entre 200 e 500."
      ];
      doc.autoTable({
        startY: 151,
        margin: { left: 26, right: 26, top: 151, bottom: 30 },
        head: [this.headers.map(header => header.text)],
        body: this.results.map(animal => [
          animal.register || "-",
          animal.name || "-",
          ...animal.services.map(serviceAnimal => serviceAnimal ? " " : "-")
        ]),
        theme: "grid",
        rowPageBreak: "avoid",
        styles: { font: "helvetica", fontSize: 6, cellPadding: 3, minCellHeight: 38, valign: "middle" },
        headStyles: { fillColor: [21, 11, 50], textColor: 255, fontStyle: "bold", minCellHeight: 24 },
        columnStyles: { 0: { cellWidth: 66 }, 1: { cellWidth: 90 } },
        didDrawPage: () => drawOfficialHeader(doc, { logo, title: "RELATÓRIO R2", details }),
        didDrawCell: ({ section, row, column, cell }) => {
          if (section !== "body" || column.index < 2) return;
          const serviceAnimal = this.results[row.index]?.services[column.index - 2];
          if (!serviceAnimal) return;
          const lines = [
            ["CCS", serviceAnimal.ccs], ["Leite", serviceAnimal.weight_total],
            ["Gord", serviceAnimal.fat], ["Prot", serviceAnimal.protein],
            ["Ureia", serviceAnimal.urea]
          ];
          doc.setFont("helvetica", "normal");
          doc.setFontSize(5.8);
          lines.forEach(([label, value], index) => {
            if (!this.hasValue(value)) return;
            doc.setTextColor(index === 0 ? this.setColor(value) : "#000000");
            doc.text(`${label}: ${this.returnParsedFloat(value)}`, cell.x + 3, cell.y + 8 + index * 7);
          });
          doc.setTextColor("#000000");
        }
      });
      const filename = `relatorio_r2_${service?.code || "servico"}.pdf`;
      if (print) {
        doc.autoPrint();
        if (printWindow) printWindow.location.href = doc.output("bloburl");
        else doc.save(filename);
      } else {
        doc.save(filename);
      }
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
  },
  async mounted() {
    this.filter = {};
    this.SET_RESET_RESULTS();
    await this.actionGetCreators();
  }
}
</script>

<style scoped>
  .r2-wrapper {
    max-width: 100%;
    overflow-x: auto;
  }
  .r2-wrapper > table {
    --bs-table-accent-bg: transparent;
    border: 1px solid var(--line) !important;
    border-radius: 10px;
    border-collapse: separate;
    border-spacing: 0;
    background: white;
  }
  .r2-wrapper td {
    border: 0 !important;
    border-bottom: 1px solid #eff1f5 !important;
    box-shadow: none !important;
    vertical-align: middle;
    padding: 8px !important;
  }
  table thead td {
    background: #f6f7fa;
    color: #4b5563;
    font-size: .74rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .04em;
    white-space: nowrap;
  }
  table thead tr td:first-child { border-top-left-radius: 10px; }
  table thead tr td:last-child { border-top-right-radius: 10px; }
  table tbody {
    font-size: 0.85rem;
  }
  table tbody tr:hover {
    background: var(--jersey-yellow-soft);
  }
  .tooltip-title {
    font-weight: 600;
  }
</style>
